import React, { useState } from 'react';
import { apiUrl } from '../../../config'
import { fetchData } from '../../../utils/api';
import styles from '../../../styles/scss/system/Users.module.scss';
import { useAdminLanguage } from '../../../AdminLanguageContext';
import { translateAdmin } from '../../../utils/adminTranslations';


const UserNew = ({ rolesData, onClose, onSaved }) => {
    const { language } = useAdminLanguage();
    const translate = (text) => translateAdmin(text, language);
    const [messageNewData, setMessageNewData] = useState([])
    const [roles] = useState(rolesData);
    const [newUser, setNewUser] = useState({
        'role_id': roles && roles.length > 0 ? roles[0].id : 0,
        'username': '',
        'first_name': '',
        'last_name': '',
        'password': ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewUser((prevUser) => ({ ...prevUser, [name]: value }));
    };

    const sendData = async (dataNew) => {
        const token = localStorage.getItem('accessToken');
        const data = await fetchData(`${apiUrl}/api/sys/new-user`, "POST", token, {body: dataNew})
        if (data.request.status === 0) {
            await onSaved();
            alert(translate(data.request.message));
            onClose();
        }
        setMessageNewData(data.request.message)
    }

    return (
        <div className={styles.modalOverlay} role="presentation">
            <section className={styles.modalDialog} role="dialog" aria-modal="true" aria-labelledby="new-user-title">
                <header className={styles.modalHeader}>
                    <div>
                        <span className={styles.eyebrow}>{translate('УПРАВЛЕНИЕ ДОСТУПОМ')}</span>
                        <h2 id="new-user-title">{translate('Добавить пользователя')}</h2>
                        <p>{translate('Создайте учетную запись сотрудника и назначьте роль.')}</p>
                    </div>
                    <button type="button" className={styles.modalClose} onClick={onClose} aria-label={translate('Закрыть')}>×</button>
                </header>
                <form className={styles.modalForm}>
                    <div className={styles.modalFields}>
                        <label className={styles.modalField}>
                            <span>{translate('Логин')}</span>
                            <input required placeholder={translate('Имя пользователя')} value={newUser.username} type="text" name='username' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Имя')}</span>
                            <input required placeholder={translate('Имя')} value={newUser.first_name} type="text" name='first_name' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Фамилия')}</span>
                            <input required placeholder={translate('Фамилия')} value={newUser.last_name} type="text" name='last_name' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Пароль')}</span>
                            <input required placeholder={translate('Задайте пароль')} value={newUser.password} type="password" name="password" onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Роль')}</span>
                            <select required value={newUser.role_id} onChange={handleInputChange} name='role_id'>
                                {roles && roles.length > 0 ? (
                                    roles.map((role) => (
                                        <option key={role.id} value={role.id}>{translate(role.role_name)}</option>
                                    ))
                                ) : (
                                    <option value="">{translate('Нет ролей')}</option>
                                )}
                            </select>
                        </label>
                    </div>
                    <footer className={styles.modalFooter}>
                        <button type='button' className={styles.secondaryButton} onClick={onClose}>{translate('Отмена')}</button>
                        <button type='button' className={styles.createButton} onClick={() => sendData(newUser)}>{translate('Создать пользователя')}</button>
                    </footer>
                        {Array.isArray(messageNewData) && messageNewData.length > 0 ? (
                            messageNewData.map((mess, index) => (
                                <span className={styles.formError} key={index + 1}>{translate(mess)}</span>
                            ))
                        ) : (null)}
                </form>
            </section>
        </div>
    );
}

export default UserNew;